module.exports = __webpack_public_path__ + "static/media/Jan_2026_5.1604c098.webp";